import { theme } from '@theme';
import { FC } from 'react';
import NoResultFound from '../../../../shared/no-result-found/NoResultFound';
import { Typography } from '../../../../style';

type PortfolioNoResultFoundProps = {
  reset: () => void;
  hasAllDealsPermission: boolean;
  hasDealsAssigned: boolean;
};

const PortfolioNoResultFound: FC<PortfolioNoResultFoundProps> = ({
  reset,
  hasAllDealsPermission,
  hasDealsAssigned,
}) => {
  const isResetButton = hasAllDealsPermission || hasDealsAssigned;

  const bodyComponent: JSX.Element = (
    <>
      {hasAllDealsPermission || hasDealsAssigned ? (
        <>
          <Typography
            className='no-result-header'
            size={theme.typography.h2}
            fontWeight={theme.typography.fontWeights.semibold}
            color={theme.palette.basicGray}
          >
            No deals match your filtering criteria
          </Typography>
          <br></br>
          <Typography
            className='no-result-text'
            size={theme.typography.h4}
            fontWeight={theme.typography.fontWeights.normal}
            color={theme.palette.dusty}
          >
            Try a different combination or reset to start over
          </Typography>
        </>
      ) : (
        <>
          <Typography
            className='no-deal-assign-header'
            size={theme.typography.h2}
            fontWeight={theme.typography.fontWeights.semibold}
            color={theme.palette.basicGray}
          >
            You have no deals assigned to you at the moment
          </Typography>
          <br></br>
          <Typography
            className='no-deal-assign-text'
            size={theme.typography.h4}
            fontWeight={theme.typography.fontWeights.normal}
            color={theme.palette.dusty}
          >
            Deals can be assigned by your administrator in Store Settings
          </Typography>
        </>
      )}
    </>
  );
  return (
    <NoResultFound reset={reset} isResetButton={isResetButton} bodyComponent={bodyComponent} />
  );
};

export default PortfolioNoResultFound;
